// This funciton creates the string that is used for the labels of
// the boxes for each location.
export default function CreateDownloadLabelsString(
  selectedLocations,
  locationDetailsMap,
) {
  // The names of all the locations.
  const communityLocationNames = Object.keys(selectedLocations);

  // The list ofs orders in Grid format.
  let downloadFileGrid = `<div><table style="width: 100%; border-collapse: collapse;">`;
  // These are all the location labels.  Each location may have multiple.
  const communityLocationLabels = [];

  // Cycle through all the locations.
  communityLocationNames.forEach((communityLocation) => {
    // Cycle through all the locations and create each label.  The number
    // of labels per location is determined by the value of the dictionary.
    for (let i = 0; i < selectedLocations[communityLocation]; i++) {
      let communityLocationString = `<h3 style = "font-size : 20px; margin-bottom : 5px">${communityLocation} </h3> <h3>____ of ____  </h3>`;
      communityLocationString = communityLocationString.concat(
        `<h5 style = "font-size : 16px; margin-bottom : 5px">Address : ${locationDetailsMap[communityLocation].address} </h5>`,
      );
      communityLocationString = communityLocationString.concat(
        `<p style = "font-size : 14px; margin-bottom : 5px">Instructions : ${locationDetailsMap[communityLocation].additionalComments} </p>`,
      );
      communityLocationString = communityLocationString.concat(
        `<p style = "font-size : 14px; margin-bottom : 5px">Additional Notes : _________________________<br/>________________________________________<br/>________________________________________<br/>________________________________________ </p>`,
      );
      communityLocationLabels.push(communityLocationString);
    }
  });

  // Cycle through all the labels and put them in a nice table.
  communityLocationLabels.forEach((communityLabel, index) => {
    // If the label is odd we want it on a new row.
    if (index % 2 === 0) {
      downloadFileGrid += `<tr>`;
    }
    // Add the row styling, label, etc.
    downloadFileGrid += `<td style="width: 50%; vertical-align: top; border: 1px solid black; padding: 5px; page-break-inside: avoid;">`;
    downloadFileGrid += communityLabel;
    downloadFileGrid += `</td>`;
    // If the label is even then it's the second item and is
    // the end of the row.
    if (index % 2 !== 0) {
      downloadFileGrid += `</tr>`;
    }
  });
  // Finish the table.
  downloadFileGrid += `</table></div>`;
  // Return both the formats in list and grid.
  return [downloadFileGrid];
}
